const PATH = 'fe.components.calibrations.calibration_history_card';

const messages = {
  passed: {
    key: `${PATH}.passed`,
    defaultValue: 'Passed'
  },
  failed: {
    key: `${PATH}.failed`,
    defaultValue: 'Failed'
  },
  certificate: {
    key: `${PATH}.certificate`,
    defaultValue: 'Certificate'
  },
  downloadPdf: {
    key: `${PATH}.download_pdf`,
    defaultValue: 'Download PDF'
  },
  scoreReport: {
    key: `${PATH}.score_report`,
    defaultValue: 'Score Report'
  },
  availableUntil: {
    key: `${PATH}.available_until`,
    defaultValue: 'Available until {{date}}'
  }
};

export default messages;
